<template>
  <span class="circle" style="margin-right:53px" v-if="isShown">
    <div class="ring">
      <span class="menuItem"></span>
      <span class="menuItem"></span>
      <span class="menuItem"></span>
      <span class="menuItem icon-freeze_left deselected" @click="freezeLeft()" id="left" title="Freeze left column"></span> 
      <span class="menuItem icon-freeze_top selected" @click="freezeTop()" id="top" title="Freeze header"></span>        
      <span class="menuItem icon-freeze_both deselected" @click="freezeBoth()" id="both" title="Freeze header and left column"></span>
      <span class="menuItem"></span>
      <span class="menuItem"></span>
    </div>
    <PsImageTooltip :text="'Frozen Headers'">
      <PsIconButton :mouseout="emitMouseOut" icon="freeze_bold" class="freeze_bold" />
    </PsImageTooltip>
  </span>
</template>

<script>
export default {
  name: "PsOrbitalMenu",
  data() {
    return {
      isShown: true,
      currentSelection: "top",
    };
  },
  mounted() {
    window.Bus.$off("freezeTop");
    window.Bus.$on("freezeTop", () => {
      if(this.currentSelection !== "top") {
        this.freezeTop();  
      }
      window.Bus.$emit("hideOrbitalMenu");
    });
    
    Vue.nextTick(() => {
      if(document.querySelector("#Main").clientHeight >  document.querySelector(".container").clientHeight + 20) {
          document.querySelector(".circle").style.right = "-16px";
      } else{
         document.querySelector(".circle").style.right = "-7px";
      }
    });

    this.calculateMenu();
  },
  methods: {
    emitMouseOut(e) {
      window.Bus.$emit("mousedout",e);
    },
    clearAll() {
      document.getElementById("left").classList.remove("selected");
      document.getElementById("top").classList.remove("selected");
      document.getElementById("both").classList.remove("selected");
      document.getElementById("left").classList.add("deselected");
      document.getElementById("top").classList.add("deselected");
      document.getElementById("both").classList.add("deselected");
      var tabulatorTableContent = document.querySelector(".tabulator-table");

      Vue.nextTick(() => {
        if(document.querySelector("#Main").clientHeight >  document.querySelector(".container").clientHeight) {
          document.querySelector(".circle").style.right = "-16px";
        } else{
          document.querySelector(".circle").style.right = "-7px";
        }
    });
    
    },
    clearSelection() {
      document.getElementById("left").classList.remove("selected");
      document.getElementById("top").classList.remove("selected");
      document.getElementById("both").classList.remove("selected");
      document.getElementById("left").classList.add("deselected");
      document.getElementById("top").classList.add("deselected");
      document.getElementById("both").classList.add("deselected");
      document.getElementById(this.currentSelection).classList.remove("deselected");
      document.getElementById(this.currentSelection).classList.add("selected");
    },
    freezeLeft() {
      if (this.currentSelection === "left" && document.getElementById("left").classList.contains("selected")) {
        this.clearAll();
        window.Bus.$emit("frozen-headers-event", "off");
      } else {
        this.currentSelection = "left";
        this.clearSelection();
        window.Bus.$emit("frozen-headers-event", "left");
        var tabulatorTableContent = document.querySelector(".tabulator-table");
      if(document.querySelector("#Main").clientHeight > document.querySelector(".container").clientHeight) {
          document.querySelector(".circle").style.right = "-16px";
      } else {

         document.querySelector(".circle").style.right = "-7px";
      }
      }
    },
    freezeTop() {
      if (this.currentSelection === "top" && document.getElementById("top").classList.contains("selected")) {
        this.clearAll();
        window.Bus.$emit("frozen-headers-event", "off");
      } else {
        this.currentSelection = "top";
        this.clearSelection();
        window.Bus.$emit("frozen-headers-event", "top");
        document.querySelector(".circle").style.right = "-7px";
      }
    },
    freezeBoth() {
      if (this.currentSelection === "both" && document.getElementById("both").classList.contains("selected")) {
        this.clearAll();
        window.Bus.$emit("frozen-headers-event", "off");
      } else {
        this.currentSelection = "both";
        this.clearSelection();
        window.Bus.$emit("frozen-headers-event", "both");
        document.querySelector(".circle").style.right = "-7px";
      }
    },
    calculateMenu() {
      var items = document.querySelectorAll(".menuItem");

      for (var i = 0, l = items.length; i < l; i++) {
        items[i].style.left = (50 - 35 * Math.cos(-0.5 * Math.PI - 2 * (1 / l) * i * Math.PI)).toFixed(4) - 4 + "%";

        items[i].style.top = (50 + 35 * Math.sin(-0.5 * Math.PI - 2 * (1 / l) * i * Math.PI)).toFixed(4) - 4 + "%";
      }

      var center = document.querySelector(".freeze_bold");

      $(center).click(function(e) {
        e.preventDefault();

        document.querySelector(".circle").classList.toggle("open");
        Vue.nextTick(() => {
          document.querySelector(".ring").style.height = "128px";
          document.querySelector(".ring").style.width = "128px";
          document.querySelector(".ring").style.position = "fixed";
          document.querySelector(".ring").style.top = "15px";
          var headerWidth = document.getElementsByClassName("p4-report")[0].offsetWidth;

          // Get width of report header and subtract that amount from circle's right.
          document.querySelector(".ring").style.right = document.getElementsByClassName("circle")[0].getBoundingClientRect().right - headerWidth + 6 + "px";
        });
                window.Bus.$emit("tooltipClose");
      });

      var ring = document.querySelector(".ring");

      $(ring).mouseleave(function(e) {
        var toElement = $(e.toElement);
        // Do not close the orbital menu if the user hovers over the snowflake icon.
        if(!(toElement[0].classList.contains("icon-freeze_bold"))) {
          document.querySelector(".circle").classList.remove("open");
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../styles/ps-icon.css";

.ring {
  height: 128px;
  position: relative;
  width: 128px;
}

.circle {
  height: 25px;
  width: 25px;
  position: absolute;
  left: initial;
  right: -7px;
  top: initial;
  z-index: 1;
}

.selected {
  opacity: 1;
}

.deselected {
  opacity: 0.6;
}

.ring {
  background-color: #003f64;
  border-radius: 50%;
  opacity: 0;
  border: 2px solid #b6c8d2;
  margin-right: 25px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: scale(0.1) rotate(-270deg);
  -moz-transform: scale(0.1) rotate(-270deg);
  transform: scale(0.1) rotate(-270deg);
  -webkit-transition: all 0.4s ease-out;
  -moz-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
  position: fixed;
}

.open .ring {
  opacity: 1;
  -webkit-transform: scale(1) rotate(0);
  -moz-transform: scale(1) rotate(0);
  transform: scale(1) rotate(0);
}

.circle-icon span[class^=icon-freeze_bold] {
  -webkit-transform: scale(1.5);
  transform: scale(1.5);
  text-align:center !important;
  justify-content: center !important;
 }

.icon-freeze_both:before {
  font-size: 1.8em !important;
}

.icon-freeze_left:before {
  font-size: 1.8em !important;
}

.icon-freeze_top:before {
  font-size: 1.8em !important;
}

.open .freeze {
  border-color: #aaaaaa;
}

.menuItem {
  border-radius: 50%;
  color: #eeeeee;
  display: block;
  height: 20px;
  line-height: 20px;
  margin-left: -10px;
  margin-top: -10px;
  position: absolute;
  text-align: center;
  width: 20px;
  cursor:pointer !important;
}
</style>